import i18n from 'i18next'
import { create } from 'zustand'

import { LocalStorageService } from '@services'

import { createSelectors } from './helpers'

const SETTINGS_KEY = 'gameSettings'

export enum AppLanguage {
  RU = 'ru',
  EN = 'en',
}

export interface GameSettingsFields {
  soundMuted: boolean
  language: AppLanguage
}

interface GameSettingsState {
  isLoading: boolean
  isError: boolean
  soundMuted: boolean
  actions: {
    init: () => void
    changeSoundMuted: (muted: boolean) => void
    changeLanguage: (lang: AppLanguage) => void
  }
}

const useGameSettingsStoreBase = create<GameSettingsState>((set, get) => ({
  isLoading: true,
  isError: false,
  soundMuted: false,
  actions: {
    init: () => {
      const stored =
        LocalStorageService.getItem<GameSettingsFields>(SETTINGS_KEY)
      Howler.mute(stored?.soundMuted || false)

      set(() => ({
        soundMuted: stored?.soundMuted || false,
      }))
    },
    changeSoundMuted: (muted: boolean) => {
      LocalStorageService.setItem(SETTINGS_KEY, {
        language: i18n.language as AppLanguage,
        soundMuted: muted,
      })
      set(() => {
        return { soundMuted: muted }
      })
      Howler.mute(muted)
    },
    changeLanguage: (language: AppLanguage) => {
      LocalStorageService.setItem(SETTINGS_KEY, {
        soundMuted: get().soundMuted,
        language,
      })
      i18n.changeLanguage(language)
    },
  },
}))

export const useGameSettingsActions = () =>
  useGameSettingsStoreBase((state) => state.actions)
export const useSoundState = () =>
  useGameSettingsStoreBase((state) => state.soundMuted)

export const useGameSettings = createSelectors(useGameSettingsStoreBase)

export function getLanguage() {
  const stored = LocalStorageService.getItem<GameSettingsFields>(SETTINGS_KEY)
  const tgLanguage =
    window.Telegram?.WebApp?.initDataUnsafe?.user?.language_code
  const isAvailableTgLanguage = tgLanguage
    ? tgLanguage === AppLanguage.EN || tgLanguage === AppLanguage.RU
    : false

  return (
    stored?.language || (isAvailableTgLanguage ? tgLanguage : AppLanguage.EN)
  )
}
